const BLOCKED_ARTICLE_URLS = [
	'http://revistaanestesiar.org/index.php/rear/article/view/119',
];

const normalize = (value = '') =>
	value.toString().trim().toLowerCase().replace(/\/+$/, '');

const BLOCKED_ARTICLE_URLS_NORMALIZED = BLOCKED_ARTICLE_URLS.map(normalize);

export const isBlockedArticleItem = (item = {}) =>
	BLOCKED_ARTICLE_URLS_NORMALIZED.includes(normalize(item?.url));

export const filterBlockedArticleItems = (list = []) => {
	if (!Array.isArray(list)) return [];
	return list.filter((item) => !isBlockedArticleItem(item));
};
